// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Tailwind from "./Tailwind.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as CitationJs from "citation-js";
import * as PapersBib from "bundle-text:/static/papers.bib";

function Publications(props) {
  return React.createElement("ul", {
              ref: Caml_option.some(props.inputRef),
              className: Tailwind.divideClassName
            }, Belt_Array.mapWithIndex(Belt_Array.map(Belt_Array.map(Array.from(new CitationJs(PapersBib)), (function (prim) {
                            return new CitationJs(prim);
                          })), (function (citation) {
                        return citation.format("bibliography", {
                                    template: "citation-mla",
                                    lang: "en-us"
                                  });
                      })), (function (i, citation) {
                    return React.createElement("li", {
                                key: i.toString()
                              }, React.createElement("p", {
                                    className: Tailwind.padding
                                  }, citation));
                  })));
}

var $$Array;

var make = Publications;

export {
  $$Array ,
  make ,
}
/* react Not a pure module */
